import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from "react-intl";
import { useParams } from 'react-router-dom';
import AddToCart from './AddToCart';
import { useLocation } from 'react-router-dom';

const AddCartWrapper: FC = () => {

  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]
  const {id} = useParams<{ id?: string }>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const qrType = searchParams.get('qrType') ?? 'order';
  const isBarCode = searchParams.get('isBarCode') ?? '0';
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>{intl.formatMessage({id: 'MENU.ORDER'})}</PageTitle>
      <AddToCart id={id} qrType={qrType} isBarCode={parseInt(isBarCode)} />
    </>
  )
}

export default AddCartWrapper
